<template>
    <div>
        <b-row>
            <b-col>
                <fg-input v-model="packet" :label="$t('system.settings.loglevel.packet')"></fg-input>
            </b-col>
        </b-row>
       <b-row>
            <b-col style="padding-top:10px">
                <vSelect
                    :options="logLevelList"
                    v-model="selectedLevel"
                    :placeholder="$t('system.settings.loglevel.selectLevel')"
                    :clearable="false" class="horizontal_left"></vSelect>
            
            </b-col>
            <b-col size="2">
                <b-button class="btn-primary horizontal_right"
                    @click="onClickSet">{{ $t('system.settings.loglevel.set') }}</b-button>
            </b-col>
       </b-row>
       <b-row>
           <b-col>
            <RequestInfo style="margin-bottom: -60px;" class="bottom" :loader="requestLoading || contentLoading" type="custom" :ok="ok" :error="error" :okMsg="okMsg" :errorMsg="errorMsg"></RequestInfo>        
           </b-col>
       </b-row>
    </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
    name: "LogLevel",
    components: {
        vSelect
    },
    data: function() {
        return {
            logLevelList:['debug','info','warn','error','trace'],
            selectedLevel: "",
            packet:"",
            error: null,
            okMsg: null,
            errorMsg: null,
            requestLoading: false,
            contentLoading: false,
            ok: false
        }
    },
    methods: {
        onClickSet() {
            this.requestLoading = true
            this.$traveller_http.post('/traveller/restui/maintenance/setLogLevel', null , {
                headers: {
                     'Content-Type': 'application/json;charset=UTF-8'
                } , params :
                    { "packet": this.packet,
                      "level": this.selectedLevel 
                    }
            })
            .then( () => {
                this.requestLoading = false
                this.ok = true
                this.error = false 
                this.okMsg = "OK"
            })
            .catch( error => {
                this.error = true
                this.errorMsg = error.response.data.message
                this.ok = null
                this.okMsg = null
            } )
            .finally( ()=> {
                this.requestLoading = false
            })
        } 
    }
}
</script>
